"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));

var _numeral = _interopRequireDefault(require("numeral"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _MarketplaceFilters = _interopRequireDefault(require("../MarketplaceFilters/MarketplaceFilters"));

var _SenderGiftLanguage = _interopRequireDefault(require("../../containers/SenderGiftLanguage/SenderGiftLanguage"));

var _MarketplaceListWrapper = _interopRequireDefault(require("../MarketplaceListWrapper/MarketplaceListWrapper"));

var _MarketplaceProductListItem = _interopRequireDefault(require("../MarketplaceProductListItem/MarketplaceProductListItem"));

var _commonData = require("../../../Shared/store/commonData/commonData.shapes");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    scrollWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '524px'
    },
    filtersButton: {
      width: '100%',
      height: '48px',
      boxShadow: 'none',
      marginTop: spacing(1),
      padding: spacing(1, 3),
      color: palette.link.main,
      backgroundColor: 'transparent',
      border: "1px solid #c4c4c4",
      '&:hover': {
        backgroundColor: palette.grey.A200
      }
    },
    filtersIcon: {
      marginRight: spacing(1)
    }
  };
});

var MarketplaceProducts = function MarketplaceProducts(_ref2) {
  var goBackTitle = _ref2.goBackTitle,
      setCategories = _ref2.setCategories,
      categories = _ref2.categories,
      setTypes = _ref2.setTypes,
      types = _ref2.types,
      filters = _ref2.filters,
      titleRef = _ref2.titleRef,
      pagination = _ref2.pagination,
      showFilters = _ref2.showFilters,
      setShowFilters = _ref2.setShowFilters,
      search = _ref2.search,
      selectedSortId = _ref2.selectedSortId,
      sortItems = _ref2.sortItems,
      loadProducts = _ref2.loadProducts,
      isEmpty = _ref2.isEmpty,
      products = _ref2.products,
      isLoading = _ref2.isLoading,
      filtersOptions = _ref2.filtersOptions,
      onClose = _ref2.onClose,
      onFilterProducts = _ref2.onFilterProducts,
      onSortProducts = _ref2.onSortProducts,
      onSearchProducts = _ref2.onSearchProducts,
      onProductPreview = _ref2.onProductPreview,
      country = _ref2.country;
  var classes = useStyles();
  var emptyListText = (0, _react.useMemo)(function () {
    var hasSearch = !!search;
    var hasFilters = filtersOptions.type.length > 0 || filtersOptions.category.length > 0;

    if (hasSearch && !hasFilters) {
      return "There are no products for \"".concat(search, "\".");
    }

    if (hasSearch && hasFilters) {
      return "There are no products for \"".concat(search, "\" and selected filters.");
    }

    if (!hasSearch && hasFilters) {
      return "There are no products for selected filters.";
    }

    return 'There are no products available.';
  }, [search, filtersOptions]);
  var filtersTitle = (0, _react.useMemo)(function () {
    var filtersText = '0 filters applied';

    if (filtersOptions.type.length > 0 || filtersOptions.category.length > 0) {
      filtersText = '1 filter applied';
    }

    if (filtersOptions.type.length > 0 && filtersOptions.category.length > 0) {
      filtersText = '2 filters applied';
    }

    return "".concat(country.name, " Marketplace - ").concat(filtersText);
  }, [country, filtersOptions]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, goBackTitle && /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2,
    pt: 0,
    pl: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    className: "Body-Regular-Center-Link-Bold Text-Pointer",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    color: "inherit",
    icon: "arrow-left"
  }), " ", /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 1
  }, goBackTitle))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    position: "relative",
    height: 762,
    bgcolor: "common.white",
    borderRadius: "5px",
    "data-testid": "CreateGift.MarketplaceProducts"
  }, /*#__PURE__*/_react.default.createElement(_MarketplaceFilters.default, {
    filters: filters,
    types: types,
    setTypes: setTypes,
    categories: categories,
    setCategories: setCategories,
    isOpen: showFilters,
    onClose: function onClose() {
      return setShowFilters(false);
    },
    onFilter: onFilterProducts
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ref: titleRef,
    p: 3,
    pl: 6,
    pr: 2,
    pb: 2,
    className: "H4-Chambray"
  }, "Let\u2019s browse the Marketplace"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 2,
    pr: 2,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 1,
    width: "33%",
    pr: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.SearchField, {
    placeholder: "Search",
    value: search,
    onChange: onSearchProducts
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: "33%",
    pr: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, {
    fullWidth: true,
    margin: "normal",
    onFilterChange: onSortProducts,
    renderItems: function renderItems() {
      return sortItems.map(function (sortItem) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: sortItem.id,
          value: sortItem.id
        }, sortItem.name);
      });
    },
    value: selectedSortId,
    name: "sort",
    label: ""
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: "33%",
    onClick: function onClick() {
      return setShowFilters(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    className: classes.filtersButton
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    color: "inherit",
    icon: "sliders-h",
    className: classes.filtersIcon
  }), "Filters"))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    className: "Body-Small-Static",
    p: 2,
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Viewing ", (0, _numeral.default)(pagination.total).format('0,0'), " ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), " options"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 1,
    className: "Body-Small-Inactive"
  }, filtersTitle)), /*#__PURE__*/_react.default.createElement(_MarketplaceListWrapper.default, null, function () {
    return /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
      hasMore: pagination.total > products.length,
      className: classes.scrollWrapper,
      useWindow: false,
      initialLoad: false,
      pageStart: 0,
      loadMore: loadProducts
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isEmpty ? /*#__PURE__*/_react.default.createElement(_material.Box, {
      width: 1,
      p: 4
    }, /*#__PURE__*/_react.default.createElement(_ui.EmptyListMessage, {
      message: emptyListText
    })) : products.map(function (product) {
      return /*#__PURE__*/_react.default.createElement(_MarketplaceProductListItem.default, {
        key: product.id,
        product: product,
        onPreview: function onPreview() {
          return onProductPreview(product.id);
        }
      });
    }), isLoading && /*#__PURE__*/_react.default.createElement(_material.Box, {
      "data-testid": "CreateGift-MarketplaceLoader",
      key: 0,
      width: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      m: 4
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null))));
  })));
};

MarketplaceProducts.defaultProps = {
  goBackTitle: null,
  titleRef: null
};
MarketplaceProducts.propTypes = {
  goBackTitle: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  titleRef: _propTypes.default.object,
  setCategories: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  categories: _propTypes.default.array.isRequired,
  setTypes: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  types: _propTypes.default.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  filters: _propTypes.default.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pagination: _propTypes.default.object.isRequired,
  showFilters: _propTypes.default.bool.isRequired,
  setShowFilters: _propTypes.default.func.isRequired,
  search: _propTypes.default.string.isRequired,
  selectedSortId: _propTypes.default.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sortItems: _propTypes.default.array.isRequired,
  loadProducts: _propTypes.default.func.isRequired,
  isEmpty: _propTypes.default.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  products: _propTypes.default.array.isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  filtersOptions: _propTypes.default.object.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onFilterProducts: _propTypes.default.func.isRequired,
  onSortProducts: _propTypes.default.func.isRequired,
  onSearchProducts: _propTypes.default.func.isRequired,
  onProductPreview: _propTypes.default.func.isRequired,
  country: _commonData.Country.isRequired
};
var _default = MarketplaceProducts;
exports.default = _default;